// extracted by mini-css-extract-plugin
export default {"paye-header":"PayeReport_paye-header__FHrWR","divider":"PayeReport_divider__SYon1"};